module.exports = __webpack_public_path__ + "img/h_lunarbase1.beba8f88.svg";